import React from "react";
import { StyledHeaderImage, StyledDiv, StyledCardWrapper, StyledTitle } from "./style";

interface Props {
  imageLink: string;
  alt: string;
}

const HeaderImage: React.FC<Props> = ({ imageLink, alt }) => {
  return (
    <>
      <StyledDiv>
        <StyledHeaderImage src={imageLink} alt={alt} />
        <StyledCardWrapper>
          <StyledTitle level={2}>KarriereDagene NTNU</StyledTitle>
        </StyledCardWrapper>
      </StyledDiv>
    </>
  );
};

export default HeaderImage;
